import Link from 'next/link'

export default function Logo() {
  return (
    <Link href="/" className="flex items-center gap-1.5">
      <span
        className="text-xl font-bold tracking-tight"
        style={{ color: '#7F77DD' }}
      >
        Lycéo
      </span>
      <span className="text-xl font-bold tracking-tight text-foreground">
        Learn
      </span>
    </Link>
  )
}
